import { pdf } from "@react-pdf/renderer";
import OrdersPDF from "../exports/orderPDF/OrdersPDF";
import { OrderDataForPDF } from "../interfaces/response/OrderPdfDataResponse";
import dayjs from "dayjs";
import RebateSummaryPDF from "../exports/LoyaltyLinks/SalesSummary";
import RebatePdfDataProps from "../interfaces/props/RebatePdfDataProps";
import LoyaltyRebateInvoiceResponse from "../interfaces/response/LoyaltyRebateInvoiceResponse";
import QualifyingInvoicesPDF from "../exports/LoyaltyLinks/QualifyingInvoicesPDF";

class DowloadHelper {
  static triggerDownload(blob: Blob, filename: string) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }

  static async downloadOrdersPdf(orders: OrderDataForPDF[]) {
    const blob = await pdf(<OrdersPDF orders={orders} />).toBlob();
    const date = dayjs().format("MM.DD.YYYY");

    const name =
      orders.length === 1
        ? `My Orders - ${orders[0].customOrderNumber} - ${date}.pdf`
        : `My Orders - Download All - ${date}.pdf`;

    this.triggerDownload(blob, name);
  }

  static openAndPrintInNewWindow(blob: Blob) {
    const url = URL.createObjectURL(
      new Blob([blob], { type: "application/pdf" })
    );
    const win = window.open(url);

    if (!win) {
      return false;
    }

    const tryPrint = () => {
      try {
        win.focus();
        win.print();
      } catch {}
    };

    win.addEventListener?.("load", () => setTimeout(tryPrint, 250));
    setTimeout(tryPrint, 600);
    const cleanup = () => URL.revokeObjectURL(url);
    const interval = setInterval(() => {
      if (win.closed) {
        clearInterval(interval);
        cleanup();
      }
    }, 1000);

    setTimeout(cleanup, 60_000);

    return true;
  }

  static printWithIframe(blob: Blob) {
    const url = URL.createObjectURL(
      new Blob([blob], { type: "application/pdf" })
    );
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    iframe.src = url;

    const cleanup = () => {
      try {
        document.body.removeChild(iframe);
      } catch {}
      URL.revokeObjectURL(url);
    };

    iframe.onload = () => {
      setTimeout(() => {
        try {
          iframe.contentWindow?.focus();
          iframe.contentWindow?.print();
        } finally {
          setTimeout(cleanup, 1000);
        }
      }, 500);
    };

    document.body.appendChild(iframe);
  }

  static async printOrdersPdf(orders: OrderDataForPDF[]) {
    const blob = await pdf(<OrdersPDF orders={orders} />).toBlob();
    const opened = this.openAndPrintInNewWindow(blob);

    if (!opened) {
      this.printWithIframe(blob);
    }
  }

  static async downloadRebateSummaryPdf(data: RebatePdfDataProps) {
    const blob = await pdf(<RebateSummaryPDF data={data} />).toBlob();
    const filename = `Lansing_Loyalty_Link_${
      data.vendor
    }_ Qualifying_Sales_Summary_${data.monthYear.replace(" ", "_")}.pdf`;
    this.triggerDownload(blob, filename);
  }

  static async downloadQualifyingInvoicesPdf(
    invoices: LoyaltyRebateInvoiceResponse[],
    vendor: string,
    monthYear: string
  ) {
    const blob = await pdf(
      <QualifyingInvoicesPDF invoices={invoices} />
    ).toBlob();

    const formattedMonth = monthYear.replace(" ", "_");
    const filename = `Lansing_Loyalty_Link_${vendor}_Qualifying_Invoices_Summary_${formattedMonth}.pdf`;
    this.triggerDownload(blob, filename);
  }
}

export default DowloadHelper;
